import React from 'react';
import { Box, Typography } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import { Button } from 'reactstrap';
import colors from 'src/styles/equalution/colors';

export interface AddonCardProps {
  topLabel: string;
  title: string;
  priceLabel: React.ReactNode;
  image?: string;
  icon?: string;
  features: string[];
  isSelected: boolean;
  onToggle: () => void;
  addLabel: string;
  removeLabel: string;
}

export const AddonCard: React.FC<AddonCardProps> = ({
  topLabel,
  title,
  priceLabel,
  image,
  icon,
  features,
  isSelected,
  onToggle,
  addLabel,
  removeLabel,
}) => {
  return (
    <Box
      sx={{
        backgroundColor: colors.CREAM_HALF,
        borderRadius: '28px',
        padding: '28px 20px 24px',
        marginBottom: '60px',
        position: 'relative',
      }}>
      {/* Top pill with icon */}
      <Box
        sx={{
          border: `2px solid ${colors.SALAD}`,
          borderRadius: '12px',
          padding: '12px',
          marginInline: 'auto',
          width: '85%',
          marginTop: '-55px',
          marginBottom: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 1,
          position: 'relative',
        }}
        border={`1px solid ${colors.SALAD}`}
        bgcolor={colors.WHITE}>
        <Typography
          sx={{
            fontSize: '15px',
            fontWeight: 600,
            color: colors.OFF_BLACK,
            textAlign: 'center',
          }}>
          {topLabel}
        </Typography>
        {icon && (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              ml: 'auto',
              position: 'absolute',
              right: -25,
              bottom: -20,
            }}>
            <img
              src={icon}
              alt="icon"
              style={{ height: '50px', width: 'auto' }}
            />
          </Box>
        )}
      </Box>

      {/* Title + price */}
      <Typography
        sx={{
          fontSize: '20px',
          fontWeight: 700,
          color: colors.SALAD,
          textAlign: 'center',
          mb: 3,
          lineHeight: 1.4,
        }}>
        {title}
        <br />
        {priceLabel}
      </Typography>

      {/* Image (optional) */}
      {image && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            mb: 3,
          }}>
          <Box
            sx={{
              borderRadius: '16px',
            }}>
            <img
              src={image}
              alt={title}
              style={{ width: '160px', height: '90px' }}
            />
          </Box>
        </Box>
      )}

      {/* Features */}
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 3 }}>
        {features.map(feature => (
          <Box
            key={feature}
            sx={{
              display: 'flex',
              alignItems: 'flex-start',
            }}>
            <CheckIcon
              sx={{
                color: colors.SALAD,
                fontSize: 20,
                mt: '2px',
                mr: 1.5,
              }}
            />
            <Typography
              sx={{
                fontSize: '14px',
                lineHeight: 1.5,
                color: colors.OFF_BLACK,
              }}>
              {feature}
            </Typography>
          </Box>
        ))}
      </Box>

      {/* CTA Button */}
      <Button
        onClick={onToggle}
        style={{
          width: '100%',
          fontSize: '16px',
          fontWeight: 600,
          padding: '10px',
          borderRadius: '32px',
          backgroundColor: isSelected ? 'transparent' : colors.OFF_BLACK,
          color: isSelected ? colors.OFF_BLACK : colors.WHITE,
          border: isSelected ? `2px solid ${colors.OFF_BLACK}` : 'none',
        }}>
        {isSelected ? removeLabel : addLabel}
      </Button>
    </Box>
  );
};

export default AddonCard;
